import { render } from "./TranscribeView.vue?vue&type=template&id=ef4c243c&scoped=true&ts=true"
import script from "./TranscribeView.vue?vue&type=script&lang=ts"
export * from "./TranscribeView.vue?vue&type=script&lang=ts"

import "./TranscribeView.vue?vue&type=style&index=0&id=ef4c243c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef4c243c"]])

export default __exports__